import { Buffer } from 'buffer';

if (!('Buffer' in window)) {
  window.Buffer = Buffer;
}
